export const blockIconsTravelHotelNew = (
	<span className='material-symbols-outlined'>hotel</span>
);
